function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(fn) { try { return Function.toString.call(fn).indexOf("[native code]") !== -1; } catch (e) { return typeof fn === "function"; } }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
// WARNING: This custom element uses JQuery!
//          It also relies on the select2 jquery plugin to be loaded (happems in ts-select2.html).

import 'select2';
import WC from 'wc-util';
import init_drag_and_drop from './drag_and_drop';
import init_option_count from './option_count';
var TsSelect2 = /*#__PURE__*/function (_HTMLSelectElement) {
  function TsSelect2() {
    _classCallCheck(this, TsSelect2);
    return _callSuper(this, TsSelect2, arguments);
  }
  _inherits(TsSelect2, _HTMLSelectElement);
  return _createClass(TsSelect2, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this = this;
      //
      //  Translate JQuery's custom "change" event to a regular CustomEvent (otherwise we can not attach a
      //    plain event listener). Be aware that the onchange attribute now will be invoked for the light-weight
      //    JQuery change event AND the actual chnage CustomEvent!
      //
      $(this).on("change", function (e) {
        if (e.isTrigger) {
          WC.fireEvent(this, "change");
          return false;
        }
      });

      //
      //  Initialize the JQuery Select2 control
      //
      if (document.readyState == 'loading') {
        // we don't have enough information about the select's style yet => wait
        document.addEventListener("DOMContentLoaded", function () {
          return _this._initialize();
        });
      } else {
        this._initialize();
      }
      ;
    }
  }, {
    key: "reinitialize",
    value: function reinitialize() {
      $(this).select2("destroy");
      var sel2_opts = this._initialize_options();
      $(this).select2(sel2_opts);
      /* I don't think we need to reinitialize DND, since those events stay in place */
    }
  }, {
    key: "_initialize",
    value: function _initialize() {
      var sel2_opts = this._initialize_options();
      $(this).select2(sel2_opts);
      if (this.hasAttribute("data-orderable")) {
        init_drag_and_drop.bind(this)();
      }
      if (this.hasAttribute("data-count-start")) {
        init_option_count.bind(this)();
      }
    }
  }, {
    key: "_initialize_options",
    value: function _initialize_options() {
      var sel2_opts = {};

      // Set allow-clear and placeholder.
      // For this to work, the <option> children must be loaded (at least the first).
      // - on initial page load this is true since we wait for $(document).ready()
      // - on XHR it _seems_ to work too, but I am not sure how that can be
      var first_option = this.options[0];
      if (!this.hasAttribute("data-allow-clear") && first_option && first_option.value == '') {
        this.setAttribute("data-allow-clear", true);
      }
      if (!this.hasAttribute("data-placeholder") && first_option && first_option.value == '') {
        this.setAttribute("data-placeholder", first_option.innerHTML);
      }

      //
      // Set Ajax default options
      //
      if (this.hasAttribute("data-ajax--url")) {
        sel2_opts['ajax'] = {
          data: this._data_fn.bind(this),
          processResults: (WC.function_named(this.getAttribute("data-ajax--processResults")) || this._processResults_fn).bind(this)
        };
        sel2_opts['escapeMarkup'] = function (markup) {
          return markup;
        }; // let our custom formatter work
        sel2_opts['templateSelection'] = this._ajax_templateSelection_fn;
        sel2_opts['templateResult'] = this._ajax_templateResult_fn;
        if (!this.hasAttribute("data-ajax--delay")) this.setAttribute("data-ajax--delay", 250);
        if (!this.hasAttribute("data-minimum-input-length")) this.setAttribute("data-minimum-input-length", 2);
        this.per_page = this.getAttribute("data-per-page") || 20;
        this.search_key = this.getAttribute("data-search-key") || 'q';
      } else {
        //
        // non-ajax config
        //
        // Using suffix "-fn" since oterwise the existing data attribute overshaddows the selet2_option
        var tmpl_result_fn = WC.function_named(this.getAttribute("data-template-result-fn"));
        if (tmpl_result_fn) {
          sel2_opts["templateResult"] = tmpl_result_fn;
        }
        // Using suffix "-fn" since oterwise the existing data attribute overshaddows the selet2_option
        var tmpl_selection_fn = WC.function_named(this.getAttribute("data-template-selection-fn"));
        if (tmpl_selection_fn) {
          sel2_opts["templateSelection"] = tmpl_selection_fn;
        }
      }

      //
      //  Expose a few select2 options that are not (yet?) fully exposed via data attributes
      //
      if (this.hasAttribute("data-dropdown-parent-selector")) {
        var dropdown_sel = this.getAttribute("data-dropdown-parent-selector"),
          $dropdown_paret_el = $(dropdown_sel);
        if ($dropdown_paret_el.length == 0) {
          console.warn("Dropdown Parent " + dropdown_sel + " missing", this);
        } else {
          sel2_opts['dropdownParent'] = $dropdown_paret_el;
        }
      }
      // HACK for <dialog> element, since Top Layer makes the dropdown inaccessible
      if (!sel2_opts['dropdownParent']) {
        var ancestor_dialog = this.closest("dialog");
        if (ancestor_dialog) {
          sel2_opts['dropdownParent'] = $(ancestor_dialog);
        }
      }
      return sel2_opts;
    }
  }, {
    key: "_data_fn",
    value: function _data_fn(params) {
      // page is the one-based page number tracked by Select2
      var req_params = {
        filter: {},
        paginate: {
          page: params.page,
          per_page: this.per_page
        }
      };
      req_params['filter'][this.search_key] = params.term;
      return req_params;
    }
  }, {
    key: "_processResults_fn",
    value: function _processResults_fn(data, params) {
      params.page = params.page || 1;
      return {
        results: data.records,
        pagination: {
          more: params.page * this.per_page < data.total
        }
      };
    }

    // what to show once a row in the drop down was selected (record is what came back from Ajax)
    // templateSelection must work for AJAX results AND for possible initial selected OPTION
  }, {
    key: "_ajax_templateSelection_fn",
    value: function _ajax_templateSelection_fn(record) {
      return record.short_html || record.html || record.text;
    }

    // rows in the select2 dropdown from ajax result records
  }, {
    key: "_ajax_templateResult_fn",
    value: function _ajax_templateResult_fn(record) {
      return record.long_html || record.html || record.text;
    }
  }]);
}( /*#__PURE__*/_wrapNativeSuper(HTMLSelectElement));
;
customElements.define('ts-select2', TsSelect2, {
  "extends": "select"
});